<template>
  <div>
    <div class="d-flex align-end pb-4">
      <div style="width: 360px" class="d-flex align-end">
        <v-icon class="mr-2">{{ icon.search }}</v-icon>
        <v-text-field
          v-model="search"
          :label="$t('table.search')"
          single-line
          hide-details
          clearable
        >
        </v-text-field>
      </div>
    </div>
    <div class="rank-table">
      <v-data-table
        :headers="headers"
        :items="rows"
        item-key="key"
        :search="search"
        :locale="this.$i18n.locale"
        sort-by="_all"
        sort-desc
        dense
      >
        <template v-slot:item.key="{ item }">
          <span v-html="mark(item.key)"></span>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mdiMagnify } from "@mdi/js";
import createSearch from "@/utils/create-search";
export default {
  props: {
    headers: {
      type: Array,
      requied: true
    },
    rows: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    search: "",
    icon: {
      search: mdiMagnify
    }
  }),
  computed: {
    searchRegexArr() {
      return createSearch(this.search);
    }
  },
  methods: {
    mark(text) {
      let wrapped = String(text);
      if (this.search) {
        this.searchRegexArr.forEach(re => {
          if (wrapped.search(re) !== -1) {
            wrapped = wrapped.replace(re, "<span class='mark'>$&</span>");
          }
        });
        return wrapped;
      } else {
        return wrapped;
      }
    }
  }
};
</script>

<style scoped>
>>> .mark {
  background: orange;
}
</style>
